export enum ContactsType {
  PHONE = 'PHONE',
  LINKEDIN = 'LINKEDIN',
  GITHUB = 'GITHUB',
  TELEGRAM = 'TELEGRAM',
  ADDITIONAL_PHONE = 'ADDITIONAL_PHONE',
  BEHANCE = 'BEHANCE',
  SKYPE = 'SKYPE',
}
